module.exports = __webpack_public_path__ + "static/img/wsbx2.8632994.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wsbx2.png
// module id = 1pK3
// module chunks = 1